import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { selectTariffTypes } from 'state/quote/quote-slice';

import { useMeterType } from 'hooks/useMeterType';

export const useTariffFilters = () => {
  const { hasE7Meter: showRateTypeFilters } = useMeterType();
  const tariffTypes = useSelector(selectTariffTypes, shallowEqual);
  const uniqueTariffTypes = useMemo(() => [...new Set(tariffTypes)], [
    tariffTypes
  ]);
  const showTariffTypeFilters = uniqueTariffTypes.length > 1;
  const hasAnyFilter = showRateTypeFilters || showTariffTypeFilters;
  return {
    showRateTypeFilters,
    showTariffTypeFilters,
    hasAnyFilter
  };
};
